import React from 'react'
import Navigation from './Navigation'
import { useSteps } from './consumers'


/**
 * @returns {React.Element}
 * @constructor
 */
const View = () => {
    const { step } = useSteps()

    const Component = step.Render

    return (
        <div className='flex flex-col justify-between w-full h-full mx-auto max-w-[1140px]'>
            <Component />
            <Navigation />
        </div>
    )
}

export default View